module.exports = __webpack_public_path__ + "img/end_star.c3a95e92.png";